import { mainProductParse, mainProductWrite } from '../mainProduct'

// ============
// PARSE
// ============

export const baseProductParse = mainProductParse

// ============
// WRITE
// ============

export const baseProductWrite = mainProductWrite
